/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalculationSettingsTemplateDownloadRequest
 */
export interface CalculationSettingsTemplateDownloadRequest {
    /**
     * 
     * @type {string}
     * @memberof CalculationSettingsTemplateDownloadRequest
     */
    target: string | null;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsTemplateDownloadRequest
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsTemplateDownloadRequest
     */
    priceUnitCategoryId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CalculationSettingsTemplateDownloadRequest
     */
    priceUnitIds?: Array<number> | null;
}

/**
 * Check if a given object implements the CalculationSettingsTemplateDownloadRequest interface.
 */
export function instanceOfCalculationSettingsTemplateDownloadRequest(value: object): value is CalculationSettingsTemplateDownloadRequest {
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    return true;
}

export function CalculationSettingsTemplateDownloadRequestFromJSON(json: any): CalculationSettingsTemplateDownloadRequest {
    return CalculationSettingsTemplateDownloadRequestFromJSONTyped(json, false);
}

export function CalculationSettingsTemplateDownloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationSettingsTemplateDownloadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'target': json['target'],
        'year': json['year'],
        'priceUnitCategoryId': json['priceUnitCategoryId'] == null ? undefined : json['priceUnitCategoryId'],
        'priceUnitIds': json['priceUnitIds'] == null ? undefined : json['priceUnitIds'],
    };
}

export function CalculationSettingsTemplateDownloadRequestToJSON(json: any): CalculationSettingsTemplateDownloadRequest {
    return CalculationSettingsTemplateDownloadRequestToJSONTyped(json, false);
}

export function CalculationSettingsTemplateDownloadRequestToJSONTyped(value?: CalculationSettingsTemplateDownloadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'target': value['target'],
        'year': value['year'],
        'priceUnitCategoryId': value['priceUnitCategoryId'],
        'priceUnitIds': value['priceUnitIds'],
    };
}

